import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { BEST_OFFER_MAX_PASSENGERS_COUNT } from "shared/hooks/bestOffers";
import { PassengersCount } from "shared/lib/golObjectTypes/PassengerTypes";
import { formattedMessageParams } from "shared/messages";

import PropertiesSelect from "@components/SearchForm/PropertiesSelect";

interface IBestOfferPassengers {
  passengers: PassengersCount;
  addPassenger: (type: string) => void;
  removePassenger: (type: string) => void;
  showFlightClassInToggle?: boolean;
  centerPropertiesPanel?: boolean;
}

const { PropertiesSelectClassEconomy } = defineMessages({
  PropertiesSelectClassEconomy: formattedMessageParams(
    "SearchForm.classEconomy"
  ),
});

const BestOfferPassengers: React.FC<IBestOfferPassengers> = ({
  passengers,
  addPassenger,
  removePassenger,
  showFlightClassInToggle = true,
  centerPropertiesPanel = false,
}) => {
  const intl = useIntl();

  return (
    <div className="best-offer-passengers-selection">
      <PropertiesSelect
        intl={intl}
        passengers={passengers}
        onAddCounterHandler={addPassenger}
        onRemoveCounterHandler={removePassenger}
        isBestOfferSelect
        defaultFlightClassName={intl.formatMessage(
          PropertiesSelectClassEconomy
        )}
        selectComponentPrefix="best-offer-passengers"
        maxNumPassengers={BEST_OFFER_MAX_PASSENGERS_COUNT}
        showFlightClassInToggle={showFlightClassInToggle}
        centerPropertiesPanel={centerPropertiesPanel}
      />
    </div>
  );
};

export default BestOfferPassengers;
